export const SUBSCRIPTION_PLAN = {
  STARTER: "Starter",
  PRO: "Pro",
  PREMIUM: "Premium",
};
